/**
 * VMAP documents interface.
 * this file has copied from
 */
/**
 * AdBreak types.
 */
export var AdBreakType;
(function (AdBreakType) {
    AdBreakType["linear"] = "linear";
    AdBreakType["nonlinear"] = "nonlinear";
    AdBreakType["display"] = "display";
})(AdBreakType || (AdBreakType = {}));
/**
 * AdBreak events types.
 */
export var TrackingEvent;
(function (TrackingEvent) {
    TrackingEvent["breakStart"] = "breakStart";
    TrackingEvent["breakEnd"] = "breakEnd";
    TrackingEvent["error"] = "error";
})(TrackingEvent || (TrackingEvent = {}));
/**
 * AdSource types.
 */
export var AdSourceTypes;
(function (AdSourceTypes) {
    AdSourceTypes["VAST3"] = "vast3";
    AdSourceTypes["custom"] = "custom";
    AdSourceTypes["adTagURI"] = "adTagURL";
})(AdSourceTypes || (AdSourceTypes = {}));
/**
 * CustomAdSource types.
 */
export var customAdSourceTypes;
(function (customAdSourceTypes) {
    customAdSourceTypes["vast1"] = "vast1";
    customAdSourceTypes["vast2"] = "vast2";
    customAdSourceTypes["proprietary"] = "proprietary";
})(customAdSourceTypes || (customAdSourceTypes = {}));
/**
 * AdTagURI types.
 */
export var adTagURITypes;
(function (adTagURITypes) {
    adTagURITypes["vast1"] = "vast1";
    adTagURITypes["vast2"] = "vast2";
    adTagURITypes["vast3"] = "vast3";
    adTagURITypes["proprietary"] = "proprietary";
})(adTagURITypes || (adTagURITypes = {}));
//# sourceMappingURL=VMAP.js.map